import { render, staticRenderFns } from "./GroupSummary.vue?vue&type=template&id=11f98c3f&"
import script from "./GroupSummary.vue?vue&type=script&lang=js&"
export * from "./GroupSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports